import { API_URL, fetchWithHandling } from './api';

/**
 * Chat/mail-originated tickets. A ticket sits at pending_review-style
 * `CLARIFICATION_REQUIRED` until the backend's scope classifier says it's
 * in-scope, at which point it gets a real Jira issue -- see
 * `app.services.core.ticketClassifier.finalize_ticket`.
 */

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
});

const jsonHeaders = (token) => ({
  'Content-Type': 'application/json',
  ...authHeaders(token),
});

export const listTickets = async (token, status = null) => {
  const params = new URLSearchParams();
  if (status) params.set('status', status);
  const query = params.toString() ? `?${params}` : '';
  return fetchWithHandling(`${API_URL}/api/tickets${query}`, {
    method: 'GET',
    headers: authHeaders(token),
  });
};

export const getTicket = async (token, ticketId) =>
  fetchWithHandling(`${API_URL}/api/tickets/${ticketId}`, {
    method: 'GET',
    headers: authHeaders(token),
  });

export const addTicketComment = async (token, ticketId, text) =>
  fetchWithHandling(`${API_URL}/api/tickets/${ticketId}/comments`, {
    method: 'POST',
    headers: jsonHeaders(token),
    body: JSON.stringify({ text }),
  });

export const retryCreateTicket = async (token, ticketId) =>
  fetchWithHandling(`${API_URL}/api/tickets/${ticketId}/create`, {
    method: 'POST',
    headers: authHeaders(token),
  });
